import { Box, CircularProgress } from "@material-ui/core";
import { FC } from "react";

const Loader: FC<LoaderProps> = ({ loading, height = "100%", size = 20, children }) => {
  return loading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height={height}>
      <CircularProgress size={size} />
    </Box>
  ) : (
    <>{children}</>
  );
};

interface LoaderProps {
  loading: boolean;
  height?: string;
  size?: number;
}

export default Loader;
